import Vue from 'vue';
import VueRouter, { RouterOptions, RouteConfig } from 'vue-router';
import Page from './components/Page.vue';
import Product from './components/Product.vue';
import Compare from './components/Compare.vue';
import Order from './components/Order.vue';
import Sent from './components/Sent.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/:n(\\d+)',
        name: 'page',
        component: Page,
    },
    { path: '/product', name: 'product', component: Product },
    { path: '/compare', name: 'compare', component: Compare },
    { path: '/order', name: 'order', component: Order },
    { path: '/sent', name: 'sent', component: Sent },
    { path: '*', redirect: { name: 'page', params: { n: 1} } },
] as RouteConfig[];

export default new VueRouter({
    routes,
} as RouterOptions);

